import RingToggle from '@jetbrains/ring-ui/components/toggle/toggle'

import {getTitle} from '../EnableAgentForm.utils'

type Props = {
  className?: string
  isToggleable: boolean
  isCloud?: boolean
  enabled?: boolean
  handleToggleClick: () => unknown
  title?: string
  size?: string
  pale?: boolean
}

function EnableToggle(props: Props) {
  const {
    className,
    enabled,
    isToggleable,
    handleToggleClick,
    title,
    size,
    pale = true,
    isCloud,
  } = props
  return (
    <RingToggle
      title={title == null ? getTitle(enabled, isToggleable, isCloud) : title}
      disabled={!isToggleable}
      checked={enabled}
      className={className}
      onChange={handleToggleClick}
      pale={pale}
      size={size}
    />
  )
}

export default EnableToggle
